import c from 'classnames';

type OverlayProps = {
  className?: string;
};

export const Overlay = ({ className }: OverlayProps) => {
  return (
    <div
      className={c(
        'pointer-events-none fixed left-0 top-0 -z-10 h-full w-full bg-overlay',
        className
      )}
    />
  );
};
